import { exists } from '../runtime.js';
import { ProviderAgreementFromJSON, ProviderAgreementToJSON } from './ProviderAgreement.js';
import { ProviderEnumFromJSON, ProviderEnumToJSON } from './ProviderEnum.js';
import { SmsCountryCodeFromJSON, SmsCountryCodeToJSON } from './SmsCountryCode.js';

/* tslint:disable */
/**
* @export
* @enum {string}
*/
var ProviderEntryPointVersionEnum;
(function (ProviderEntryPointVersionEnum) {
    ProviderEntryPointVersionEnum["V6"] = "v6";
    ProviderEntryPointVersionEnum["V7"] = "v7";
})(ProviderEntryPointVersionEnum || (ProviderEntryPointVersionEnum = {}));
function ProviderFromJSON(json) {
    return ProviderFromJSONTyped(json);
}
function ProviderFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'provider': ProviderEnumFromJSON(json['provider']),
        'enabledAt': !exists(json, 'enabledAt') ? undefined : (json['enabledAt'] === null ? null : new Date(json['enabledAt'])),
        'clientId': !exists(json, 'clientId') ? undefined : json['clientId'],
        'clientSecret': !exists(json, 'clientSecret') ? undefined : json['clientSecret'],
        'providerProjectId': !exists(json, 'providerProjectId') ? undefined : json['providerProjectId'],
        'authorizationUrl': !exists(json, 'authorizationUrl') ? undefined : json['authorizationUrl'],
        'redirectUrl': !exists(json, 'redirectUrl') ? undefined : json['redirectUrl'],
        'defaultChainId': !exists(json, 'defaultChainId') ? undefined : json['defaultChainId'],
        'defaultChain': !exists(json, 'defaultChain') ? undefined : json['defaultChain'],
        'keyExportUrl': !exists(json, 'keyExportUrl') ? undefined : json['keyExportUrl'],
        'termsAcceptedByUser': !exists(json, 'termsAcceptedByUser') ? undefined : ProviderAgreementFromJSON(json['termsAcceptedByUser']),
        'appleKeyId': !exists(json, 'appleKeyId') ? undefined : json['appleKeyId'],
        'appleTeamId': !exists(json, 'appleTeamId') ? undefined : json['appleTeamId'],
        'accountSid': !exists(json, 'accountSid') ? undefined : json['accountSid'],
        'twilioNumber': !exists(json, 'twilioNumber') ? undefined : json['twilioNumber'],
        'enabledCountries': !exists(json, 'enabledCountries') ? undefined : (json['enabledCountries'].map(SmsCountryCodeFromJSON)),
        'entryPointVersion': !exists(json, 'entryPointVersion') ? undefined : json['entryPointVersion'],
    };
}
function ProviderToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'provider': ProviderEnumToJSON(value.provider),
        'enabledAt': value.enabledAt === undefined ? undefined : (value.enabledAt === null ? null : value.enabledAt.toISOString()),
        'clientId': value.clientId,
        'clientSecret': value.clientSecret,
        'providerProjectId': value.providerProjectId,
        'authorizationUrl': value.authorizationUrl,
        'redirectUrl': value.redirectUrl,
        'defaultChainId': value.defaultChainId,
        'defaultChain': value.defaultChain,
        'keyExportUrl': value.keyExportUrl,
        'termsAcceptedByUser': ProviderAgreementToJSON(value.termsAcceptedByUser),
        'appleKeyId': value.appleKeyId,
        'appleTeamId': value.appleTeamId,
        'accountSid': value.accountSid,
        'twilioNumber': value.twilioNumber,
        'enabledCountries': value.enabledCountries === undefined ? undefined : (value.enabledCountries.map(SmsCountryCodeToJSON)),
        'entryPointVersion': value.entryPointVersion,
    };
}

export { ProviderEntryPointVersionEnum, ProviderFromJSON, ProviderFromJSONTyped, ProviderToJSON };
